import { usePathCoordinates } from "@Hooks/usePathCoordinates";
import { ForecastPointWeek } from "@MeteoApi/models/ForecastPointWeek";
import { ForecastService } from "@MeteoApi/services/ForecastService";
import { getValidForecastPointWeek } from "@Utils/interval";
import { useEffect, useState } from "react";

type UseForecastPointWeek = {
  forecastPointWeek: ForecastPointWeek;
  error?: Error;
};

export const useForecastPointWeek = (
  geolcationIdFallback?: string | null,
): UseForecastPointWeek => {
  const coordinates = usePathCoordinates();

  const [forecastPointWeek, setForecastPointWeek] =
    useState<ForecastPointWeek>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    const geolocationId = coordinates
      ? `${coordinates.lat},${coordinates.lng}`
      : geolcationIdFallback;

    if (!geolocationId) {
      return;
    }

    const promise = ForecastService.getForecastWeekByGeoLocation({
      geolocationId: geolocationId,
    });

    promise
      .then((forecastPointWeek: ForecastPointWeek) => {
        setForecastPointWeek(getValidForecastPointWeek(forecastPointWeek));
        setError(undefined);
        return;
      })
      .catch((e: Error) => {
        // eslint-disable-next-line no-console
        console.error(e);
        setError(e);
      });
  }, [coordinates, geolcationIdFallback]);

  return { forecastPointWeek: forecastPointWeek as ForecastPointWeek, error };
};
